module.exports = __webpack_public_path__ + "img/factory_plate_character.ba82b107.jpg";